import { ENVIRONMENT } from 'src/app/constants';
import { IAutorizacoes } from './../../interfaces/token/IAutorizacoes';
import { AuthenticationService } from './../../services/authentication/authentication.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Environment } from 'src/app/types';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.scss']
})
export class MenuLateralComponent implements OnInit {
  @ViewChild('financeiroCollapse') financeiroCollapse: NgbCollapse;
  @ViewChild('servicosCollapse') servicosCollapse: NgbCollapse;
  @ViewChild('suprimentosCollapse') suprimentosCollapse: NgbCollapse;
  isFinanceiroCollapsed = true;
  isServicosCollapsed = true;
  isSuprimentosCollapsed = true;
  autorizacoes: IAutorizacoes;
  routerlink = '';
  // documentos = '/documentos';

  constructor(
    private authenticationService: AuthenticationService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  ngOnInit() {
    this.getUserPermissoes();
  }

  toggleCollapse(modulo: string) {
    if (modulo === 'financeiro') {
      this.financeiroCollapse.toggle();
      this.isServicosCollapsed = true;
      this.isSuprimentosCollapsed = true;
      return;
    }
    if (modulo === 'servicos') {
      this.servicosCollapse.toggle();
      this.isFinanceiroCollapsed = true;
      this.isSuprimentosCollapsed = true;
      return;
    }
    if (modulo === 'suprimentos') {
      this.suprimentosCollapse.toggle();
      this.isFinanceiroCollapsed = true;
      this.isServicosCollapsed = true;
      return;
    }
  }

  getUserPermissoes() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];
  }

  sair() {
    this.authenticationService.logoutUsuario();
  }
}
